import { useContext } from 'react';
import { PeriodViewContext } from 'src/sections/view_checkbook/PeriodViewContext';

const usePeriodView = () => {
  const context = useContext(PeriodViewContext);
  if (!context)
    throw new Error('Period View context must be used inside PeriodViewContextProvider');
  return context;
};

export default usePeriodView;
